import { getVideoLayerSpecificUrl } from '../video-layer.urls';
import { IVideoLayerContext } from '../../../../../models/project/take/layers/video-layer-model';

class VideoLayerUrls {
    public getFinishedRecordingPUTUrl(videoLayerContext: IVideoLayerContext) {
        const basePath = this.getDetailsVideoUrlsPath(videoLayerContext);

        return `${basePath}/finished-recording`;
    }

    public getUpdateVideoLayerDetailsFieldsPUTUrl(videoLayerContext: IVideoLayerContext) {
        const basePath = this.getDetailsVideoUrlsPath(videoLayerContext);
        return `${basePath}`;
    }

    public getRemoveVideoLayerDELETEUrl(videoLayerContext: IVideoLayerContext) {
        const basePath = this.getDetailsVideoUrlsPath(videoLayerContext);
        return `${basePath}`;
    }

    public getDetailsVideoUrlsPath(videoLayerContext: IVideoLayerContext) {
        const specificVideoLayerPath = getVideoLayerSpecificUrl(
            videoLayerContext.projectId,
            videoLayerContext.sceneId,
            videoLayerContext.takeId,
            videoLayerContext.videoLayerId
        );
        return specificVideoLayerPath;
    }
}

export const videoLayerUrls = new VideoLayerUrls();
